module.exports = __webpack_public_path__ + "static/media/14UNEP28.158f074e.jpg";